import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Flex,
  Text,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  TabPanel,
  TabPanels,
  Tabs,
  useBreakpointValue,
} from "@chakra-ui/react";

import { IoMdAnalytics } from "react-icons/io";
import { FaTasks, FaBookReader, FaChevronDown } from "react-icons/fa";
import { PiArticleMediumFill } from "react-icons/pi";
import { GiNotebook } from "react-icons/gi";
// import {
//   MdNotificationsActive,
//   MdOutlineDashboardCustomize,
// } from 'react-icons/md';

import theme from "ui/theme/theme";
import { StudentTabs } from "./StudentTabsData";
import {
  // ContentContainer,
  StyledTab,
  StyledTabList,
  StyledIconTab,
  LinkTab,
  ToolsSideNav,
  Wrapper,
} from "./StudentProfile.styles";
import CenteredWrapper from "ui/CenteredWrapper";

function SubTab({ icon, text, path, onClick, selected }) {
  function getFontWeight() {
    let fontWeight;
    if (selected) {
      fontWeight = "bold";
    } else if (icon) {
      fontWeight = "semibold";
    } else {
      fontWeight = "unset";
    }
    return fontWeight;
  }

  return (
    <LinkTab to={`/student-profile/${path}`} selected={selected} icon={icon}>
      <StyledIconTab onClick={onClick} icon={icon}>
        {icon}
        <Text
          size="small"
          textDecoration={selected ? "underlin" : "none"}
          fontWeight={getFontWeight()}
          ml={icon ? "8px" : "28px"}
          minWidth="80px"
          _hover={{ fontWeight: "bold" }}
        >
          {text}
        </Text>
      </StyledIconTab>
    </LinkTab>
  );
}

SubTab.propTypes = {
  icon: PropTypes.element,
  text: PropTypes.string,
  path: PropTypes.string,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
};

function IconTab({ icon, text, path, onClick, selected }) {
  function getFontWeight() {
    let fontWeight;
    if (icon) {
      fontWeight = "semibold";
    } else {
      fontWeight = "unset";
    }
    return fontWeight;
  }

  return (
    <LinkTab to={`/student-profile/${path}`} selected={selected} icon={icon}>
      <StyledIconTab onClick={onClick} icon={icon}>
        {icon}
        <Text
          size="small"
          fontWeight={getFontWeight()}
          ml={icon ? "8px" : "28px"}
          minWidth="80px"
        >
          {text}
        </Text>
      </StyledIconTab>
    </LinkTab>
  );
}

IconTab.propTypes = {
  icon: PropTypes.element,
  text: PropTypes.string,
  path: PropTypes.string,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
};

function StudentProfile() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState("dashboard");
  const isMobile = useBreakpointValue({ base: true, lg: false });

  const path = "/student-profile";
  if (location.pathname === `${path}` || location.pathname === `${path}/`) {
    navigate(`${path}/reports`);
  }

  const findPathEnd = (pathname) =>
    pathname.substring(pathname.lastIndexOf(path) + path.length + 1);
  const pathEnd = findPathEnd(location.pathname);

  const defaultIndex = StudentTabs.filter(
    (tab) => tab.name !== "break"
  ).findIndex((tab) => pathEnd.includes(tab.link));
  const [selectedIndex, setSelectedIndex] = useState(defaultIndex);

  useEffect(() => {
    setSelectedTab(findPathEnd(location.pathname));
  }, [navigate, location.pathname]);

  function handleTabSelection(tabLink) {
    navigate(`${path}/${tabLink}`);
    const currentTabIndex = StudentTabs.filter(
      (tab) => tab.name !== "break"
    ).findIndex((tab) => tab.link === tabLink);
    setSelectedIndex(currentTabIndex);
  }

  const MobileTabMenu = (
    <Flex
      w={{ base: "calc(100% + 32px)", md: "calc(100% + 64px)" }}
      mt="60px"
      mx={{ base: "-24px", md: "-30px" }}
      boxShadow="0px 4px 15px -4px rgba(0, 0, 0, 0.15)"
    >
      <Menu placement="bottom">
        <MenuButton w="100%" h="48px" bg="gray.50">
          {StudentTabs.map(
            (tab, idx) =>
              selectedTab.includes(tab.link) && (
                <Flex
                  key={idx}
                  align="center"
                  justify="space-between"
                  px="24px"
                >
                  <Text ml={8}>{tab.name}</Text>
                  <FaChevronDown size="16px" />
                </Flex>
              )
          )}
        </MenuButton>
        <MenuList border="0px" w="100vw">
          {StudentTabs.map(
            (tab) =>
              tab.name !== "break" && (
                <MenuItem key={tab.link} px="24px">
                  <StyledTab
                    key={tab.key}
                    color={
                      selectedTab.includes(tab.name) &&
                      theme.colors.primary.default
                    }
                    onClick={() => handleTabSelection(tab.link)}
                  >
                    {tab.icon}
                    <Text
                      fontWeight={selectedTab.includes(tab.link) && "bold"}
                      marginLeft="10px"
                      minWidth="80px"
                    >
                      {tab.name}
                    </Text>
                  </StyledTab>
                </MenuItem>
              )
          )}
        </MenuList>
      </Menu>
    </Flex>
  );

  return (
    <CenteredWrapper
      px={{ base: "0px", md: "32px", lg: "16px" }}
      py={isMobile ? "0px" : "40px"}
      mt={isMobile ? "8px" : "32px"}
      mb={isMobile ? "12px" : "32px"}
    >
      <Tabs
        flexDirection={isMobile ? "column" : "row"}
        orientation="vertical"
        height="auto"
        index={selectedIndex}
      >
        {isMobile ? (
          MobileTabMenu
        ) : (
          <Box display={{ base: "none", lg: "block" }}>
            <ToolsSideNav>
              <Wrapper padding="24px 0px 8px 0px">
                <Text fontWeight="bold" mb="24px" pl="20px">
                  MY LEARNING
                </Text>
                <StyledTabList>
                  {/* <IconTab
                    icon={<MdOutlineDashboardCustomize size="20px" />}
                    text="Dashboard"
                    path="dashboard"
                    onClick={() => handleTabSelection('dashboard')}
                    selected={selectedTab === 'dashboard'}
                  /> */}
                  <IconTab
                    icon={<FaTasks size="20px" />}
                    text="Assignment"
                    path="assignment"
                    onClick={() => handleTabSelection("assignment")}
                    selected={selectedTab === "assignment"}
                  />
                  <IconTab
                    icon={<PiArticleMediumFill size="20px" />}
                    text="Essay"
                    path="essay"
                    onClick={() => handleTabSelection("essay")}
                    selected={selectedTab === "assay"}
                  />
                  <IconTab
                    icon={<FaBookReader size="20px" />}
                    text="Storytelling"
                    path="storytelling"
                    onClick={() => handleTabSelection("storytelling")}
                    selected={selectedTab === "storytelling"}
                  />
                  <IconTab
                    icon={<GiNotebook size="20px" />}
                    text="Diary"
                    path="diary"
                    onClick={() => handleTabSelection("diary")}
                    selected={selectedTab === "diary"}
                  />
                  <IconTab
                    icon={<IoMdAnalytics size="20px" />}
                    text="Reports"
                    path="reports"
                    onClick={() => handleTabSelection("reports")}
                    selected={selectedTab === "reports"}
                  />
                  {/* <IconTab
                    icon={<MdNotificationsActive size="20px" />}
                    text="Message"
                    path="message"
                    onClick={() => handleTabSelection('message')}
                    selected={selectedTab === 'message'}
                  /> */}
                </StyledTabList>
              </Wrapper>
            </ToolsSideNav>
          </Box>
        )}
        <Box
          display="flex"
          justifyContent="center"
          w="full"
          minW="sm"
          px={{ base: "40px", md: "20px", lg: "0px" }}
          mt={{ base: "30px", md: "10", lg: "0px" }}
        >
          <TabPanels>
            {StudentTabs.map((tab) => (
              <TabPanel
                p={isMobile ? "0px" : "1rem"}
                key={`${tab.key}-tabpanel`}
              >
                {tab.content}
              </TabPanel>
            ))}
          </TabPanels>
        </Box>
      </Tabs>
    </CenteredWrapper>
  );
}

export default StudentProfile;
